import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Button, Col, Container, Form, Image, InputGroup, Row, Spinner } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { LoginInfo } from '../App';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import FollowButton from './FollowButton';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import Masonry from "react-masonry-css";
import { FaHatCowboy } from 'react-icons/fa';
import Tile from './common/Tile';
import Thumb from './common/Thumb';
import DocumentTile from './common/DocumentTile';
import VideoTile from './common/VideoTile';
import EventTile from './common/EventTile';
import { ModelCard, ModelInfoDialog } from './generate/ModelSelector';
import { isLoggin, updateRenzoku, updateTile } from '../service/LoginService';
import { Chip, Tab, Tabs, Box, CircularProgress, Typography, Grid } from '@mui/material';
import MuiButton from '@mui/material/Button';
import CommonDialog from './common/CommonDialog';
import AgeSelect from './AgeSelect';
import TaggedImageSlider from './common/TaggedImageSlider';
import Gallery from './common/Gallery';
import { imgPath } from '../service/CommonUtil';

const New = () => {
    async function getUserSetting(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/userSetting/my")
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getImage(style,generalOrAI,tag,page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/new/"+style+"/"+generalOrAI+"/"+tag+"/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    
    // コンテンツタイプに応じたデータ取得関数
    async function getContentData(contentType, style, generalOrAI, tag, page) {
        switch(contentType) {
            case 'image':
                return await getImage(style, generalOrAI, tag, page);
            case 'text':
                // TODO: 文書用API実装後に追加
                try {
                    return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/text/new/"+generalOrAI+"/"+(tag.length === 0 ? "all" : "")+"//"+page).then((r)=>r.json().then((json)=>{
                        return json
                    }));
                } catch {
                    // 暫定的にダミーデータを返す
                    return { 
                        result: true, 
                        data: [
                            {
                                id: 1,
                                title: "サンプル文書1",
                                description: "これは文書コンテンツのサンプルです。",
                                content_type: 'text',
                                user_name: "テストユーザー1",
                                created_at: "2024-01-15T10:00:00Z"
                            },
                            {
                                id: 2,
                                title: "技術仕様書",
                                description: "システムの技術仕様について詳しく説明したドキュメントです。",
                                content_type: 'text',
                                user_name: "開発者",
                                created_at: "2024-01-14T15:30:00Z"
                            }
                        ]
                    };
                }
            case 'video':
                // TODO: 動画用API実装後に追加
                try {
                    return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/video/new/all/"+generalOrAI+"/"+tag+"/"+page).then((r)=>r.json().then((json)=>{
                        return json
                    }));
                } catch {
                    // 暫定的にダミーデータを返す
                    return { 
                        result: true, 
                        data: [
                            {
                                id: 1,
                                title: "サンプル動画1",
                                content_type: 'video',
                                user_name: "クリエイター1",
                                duration: 180,
                                thumbnail_url: null
                            },
                            {
                                id: 2,
                                title: "チュートリアル動画",
                                content_type: 'video',
                                user_name: "教育チャンネル",
                                duration: 420,
                                thumbnail_url: null
                            }
                        ]
                    };
                }
            case 'event':
                // TODO: イベント用API実装後に追加
                try {
                    return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/event/new/"+page).then((r)=>r.json().then((json)=>{
                        return json
                    }));
                } catch {
                    // 暫定的にダミーデータを返す
                    return { 
                        result: true, 
                        data: [
                            {
                                id: 1,
                                title: "開発者ミートアップ",
                                description: "最新の技術トレンドについて議論するイベントです。",
                                content_type: 'event',
                                user_name: "イベント主催者",
                                event_date: "2024-02-15T19:00:00Z",
                                location: "東京都渋谷区",
                                participants_count: 25
                            },
                            {
                                id: 2,
                                title: "デザインワークショップ",
                                description: "UI/UXデザインのベストプラクティスを学ぶワークショップです。",
                                content_type: 'event',
                                user_name: "デザイン集団",
                                event_date: "2024-01-20T14:00:00Z",
                                location: "オンライン",
                                participants_count: 50
                            }
                        ]
                    };
                }
            case 'model':
                // モデル用API
                try {
                    return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/modelList/1").then((r)=>r.json().then((json)=>{
                        return json
                    }));
                } catch {
                    // 暫定的にダミーデータを返す
                    return { 
                        result: true, 
                        data: [
                            {
                                id: 1,
                                name: "サンプルモデル1",
                                description: "これは3Dモデルのサンプルです。",
                                content_type: 'model',
                                user_name: "モデルクリエイター1",
                                created_at: "2024-01-15T10:00:00Z",
                                model_type: "3D",
                                file_size: "25MB"
                            },
                            {
                                id: 2,
                                name: "建築モデル",
                                description: "現代建築の3Dモデルです。",
                                content_type: 'model',
                                user_name: "建築デザイナー",
                                created_at: "2024-01-14T15:30:00Z",
                                model_type: "3D",
                                file_size: "45MB"
                            }
                        ]
                    };
                }
            case 'all':
            default:
                // 全コンテンツタイプの場合は画像データを返す（将来的には統合APIを使用）
                return await getImage(style, generalOrAI, tag, page);
        }
    }
    async function getMessage(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/messages/info").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    // ナビゲーション
    const navigate = useNavigate()

    useEffect(() => {
        if(loginInfo.result){
            // 連続投稿の表示減らす
            setOmitContinuous(loginInfo.renzoku === 1)
            // タイルモード
            setTileMode(loginInfo.tile === 1)
        }
    },[loginInfo])

    // パラメータ
    let param = useParams()
    let style = param.style_of_painting
    let generalOrAI = param.general_or_ai || "all"
    let tag = param.tag || ""
    let genre = {undefined:"("+t("common.general")+")","general":"("+t("common.general")+")","r18":"(R18)","r18g":"(R18G)","all":"("+t("common.all")+")"}

    const [userSetting, setUserSetting] = useState([]);
    const [messageList,setMessageList] = useState([])
    const [imageList,setImageList] = useState([])
    const [imagePage,setImagePage] = useState(1)
    const [oldGeneralOrAI,setOldGeneralOrAI] = useState([])
    const [imageListReset,setImageListReset] = useState(false)
    const [styleOfPainting,setStyleOfPainting] = useState(style || "all")
    const [loading,setLoading] = useState(true)
    
    // コンテンツタイプ関連のstate
    const [contentType, setContentType] = useState('image')
    const [oldContentType, setOldContentType] = useState('all')
    const [contentList, setContentList] = useState([]) // imageListの代わりに使用

    // 投稿遅延ロード
    const options = {
        root: null,
        rootMargin: "1000px",
        threshold: 0.05
    }
    const observer = new IntersectionObserver((entries,observer)=>{
        entries.forEach(entry => {
            if(entry.intersectionRatio > 0){
                const imgEl = entry.target;
                //imgEl.src = imgEl.dataset.src;          
                observer.unobserve(entry.target);
                // ロードした部分まで進んだら追加読み込み
                if(imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (imagePage * 50 - 1) ){
                    setImagePage(imagePage+1)
                }
              }
        })
    }, options);

    useEffect(() => {
        let tempGenre = generalOrAI
        if(generalOrAI === undefined){
            tempGenre = "general"
        }
        
        setLoading(true)
        // コンテンツタイプに応じてデータを取得
        getContentData(contentType, styleOfPainting, tempGenre, tag, imagePage).then(r => {
            if(r.result){
                if(r.data.length > 0){
                    if(oldGeneralOrAI === tempGenre && oldContentType === contentType && !imageListReset){
                        // 既存データに追加（ページネーション）
                        setImageList(imageList.concat(r.data))
                        setContentList(contentList.concat(r.data))
                    } else {
                        // 新規データで置き換え
                        setImageList([].concat(r.data))
                        setContentList([].concat(r.data))
                        setImageListReset(false)
                    }
                } else {
                    if(imagePage === 1){
                        setImageList([])
                        setContentList([])
                        const contentTypeLabel = {
                            'all': 'コンテンツ',
                            'image': '画像',
                            'text': 'テキスト',
                            'video': '動画',
                            'event': 'イベント'
                        }[contentType] || 'コンテンツ';
                        dialog("","まだ" + contentTypeLabel + "の投稿がありません。1つ目を投稿しませんか？")
                    }
                }
            } else {
                setImageList([])
                setContentList([])
                dialog("確認",r.errors)
            }
            setLoading(false)
        })
        setOldGeneralOrAI(tempGenre)
        setOldContentType(contentType)
    },[imagePage,styleOfPainting,generalOrAI,tag,contentType])

    useEffect(() => {
        // ユーザ設定
        getUserSetting().then(r => {
            if(r.result){
                setUserSetting(r)
            }
        })
        // メッセージ取得
        getMessage().then(r=>{
            if(r.result){
                setMessageList(r.data)
            }
        })
        // タイトル設定
        document.querySelector("title").textContent = "新着 | アワートAI - AI活用プラットフォーム"

    },[])

    const [omitContinuous,setOmitContinuous] = useState(false)
    const [tileMode,setTileMode] = useState(true)
    const [showSetting,setShowSetting] = useState(false)
    const [favoriteLoading, setFavoriteLoading] = useState({})

    // モデル関連の関数
    const toggleFavoriteApi = async (modelId, isFavorite) => {
        try {
        const method = isFavorite ? 'delete' : 'post';
        const response = await new ApiFetch()[method](
            `${ApiFetch.API_PROTOCOL}//${ApiFetch.API_HOST}/v1/favorite/image_ai_model/${modelId}`,
            method === 'post' ? {} : undefined
        );
        return await response.json();
        } catch (error) {
        console.error('Error toggling favorite:', error);
        return { result: false };
        }
    };
    const handleToggleFavorite = async (modelId) => {
        setFavoriteLoading(prev => ({ ...prev, [modelId]: true }));
        const targetModel = contentList.find(model => model.id === modelId);
        if (!targetModel) {
        setFavoriteLoading(prev => ({ ...prev, [modelId]: false }));
        return;
        }

        const isFavorite = targetModel.favorite === 1;
        const response = await toggleFavoriteApi(modelId, isFavorite);

        if (response.result) {
        setContentList(prevModels => prevModels.map(model => {
            if (model.id === modelId) {
                return { ...model, favorite: model.favorite === 1 ? 0 : 1 };
            }
            return model;
        }));
        } else {
        console.error('Favorite toggle failed:', response);
        }

        setFavoriteLoading(prev => ({ ...prev, [modelId]: false }));
    };

    const [infoDialogOpen, setInfoDialogOpen] = useState(false);
    const [selectedModelForInfo, setSelectedModelForInfo] = useState(null);
    const [dialogSelectedModel, setDialogSelectedModel] = useState();
    const handleShowInfo = (modelId) => {
        const model = contentList.find(m => m.id === modelId);
        if (model) {
        setSelectedModelForInfo(model);
        setInfoDialogOpen(true);
        }
    };

    // 画像遅延ロード
    useEffect(() => {
        document.querySelectorAll(".lazy").forEach(e => {
            if(e.dataset.lazy !== "1"){
                observer.observe(e)
                e.dataset.lazy = "1"
            }
        })
    },[imageList,tileMode,contentList])
    
    // コンテンツタイプに応じたレンダリング関数
    const renderContent = (data, i) => {
        // データにコンテンツタイプが含まれていない場合は画像として扱う
        const itemContentType = data.content_type || 'image';
        
        switch(itemContentType) {
            case 'text':
                return <DocumentTile 
                    key={i} 
                    data={data} 
                    onClick={(data) => dialog("文書", "文書の詳細表示機能は実装予定です")}
                    className="m-2"
                />;
            case 'video':
                return <VideoTile 
                    key={i} 
                    data={data} 
                    onClick={(data) => dialog("動画", "動画の詳細表示機能は実装予定です")}
                    className="m-2"
                />;
            case 'event':
                return <EventTile 
                    key={i} 
                    data={data} 
                    onClick={(data) => dialog("イベント", "イベントの詳細表示機能は実装予定です")}
                    className="m-2"
                />;
            case 'model':
                return <ModelCard
                    key={i}
                    model={data}
                    onSelect={() => {
                        navigate('/model/' + data.model_id);
                    }}
                    onToggleFavorite={() => handleToggleFavorite(data.id)}
                    onShowInfo={() => handleShowInfo(data.id)}
                    isLoading={favoriteLoading?.[data.id]}
                    className="m-2"
                />;
            case 'image':
            default:
                // 既存の画像表示ロジック
                if(data.mute === 1 || (omitContinuous && i > 0 && contentList[i-1]?.user_id === data.user_id) || (data.user_id !== loginInfo.userId && data.search_ban === 1)){
                    return <span data-no={i} className="lazy" key={i}></span>
                }
                return <Thumb data={data} i={i} dialog={dialog} key={i} observer={observer} list={contentList.filter(d => d.mute === 0)} listName={t(("category.new"))} />
        }
    }

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    const breakpointColumnsObj = {
        default: 9,
        1800: 8,
        1600: 7,
        1400: 6,
        1200: 5,
        992: 4,
        768: 3,
        576: 2,
    }
    const gridBreakpoints = {
        xs: 2, // Extra small devices (phones)
        sm: 3, // Small devices (tablets)
        md: 4, // Medium devices (small laptops)
        lg: 5, // Large devices (desktops)
        xl: 6, // Extra large devices (large desktops)
    };

    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <CommonDialog open={show}
            content={dialogMessage}
            onClick={() => {
                setShow(false)
            }} onClose={() => setShow(false)}
            title={dialogTitle} />
        <Header />
        <Category />        
        <Container style={{backgroundColor:"#FFFFFF"}} className='m-0 p-0'>
            <Container className='p-0' style={{backgroundColor:"inherit"}}>
                <div className='p-0' style={{position:"fixed",zIndex:2,width:"100%",top:"68px",backgroundColor:"inherit",overflow:"auto"}} id="category-bar">
                    <div className='mt-1 mb-1' style={{width:"100%",maxWidth:"900px",fontSize:"24px",fontWeight:"bold",backgroundColor:"inherit",overflowX:"auto"}}>
                        <Tabs 
                            variant='scrollable' 
                            scrollButtons="auto"
                            allowScrollButtonsMobile
                            value="new" 
                            onChange={(e) => {
                                switch(e.target.tabIndex){
                                    case 0:
                                        navigate("/")
                                    break
                                    case 1:
                                        navigate("/new")
                                    break
                                    case 2:
                                        navigate("/osusume")
                                    break
                                    case 3:
                                        navigate("/ranking")
                                    break
                                    case 4:
                                        navigate("/random")
                                    break
                                    case 5:
                                        navigate("/newFollow")
                                    break
                                    case 6:
                                        navigate("/newUser")
                                    break
                                }
                            }}
                            sx={{
                                '& .MuiTab-root': {
                                    minWidth: { xs: '60px', sm: '80px' },
                                    fontSize: { xs: '11px', sm: '14px' },
                                    padding: { xs: '6px 4px', sm: '12px 16px' }
                                }
                            }}
                        >
                            <Tab label={"Top"} value="0" tabIndex={0}></Tab>
                            <Tab label={t("home.new")} value="new" tabIndex={1} onClick={() => navigate("/new")}></Tab>
                            <Tab label={t("osusume.title")} value="osusume" tabIndex={2}></Tab>
                            <Tab label={t("category.ranking")} value="ranking" tabIndex={3}></Tab>
                            <Tab label={t("category.discover")} value="random" tabIndex={4}></Tab>
                            <Tab label={t("newFollow.title")} value="newFollow" tabIndex={5}></Tab>
                            <Tab label={t("newUser.title")} value="newUser" tabIndex={6}></Tab>
                            <Icon.GearFill
                            onClick={() => setShowSetting(!showSetting)}
                            style={{fontSize:"28px",marginLeft:"8px",marginRight:"8px",cursor:"pointer"}} />
                        </Tabs>
                    </div>
                </div>
                <div className='p-0' style={{position:"fixed",top:"122px",width:"100%",zIndex:2,backgroundColor:"#FFFFFF",overflow:"auto"}} id="tag-bar">
                    <div className='mt-1 mb-1' style={{width:"100%",maxWidth:"1700px",fontSize:"24px",fontWeight:"bold",backgroundColor:"inherit",overflowX:"auto"}}>
                        {/* コンテンツタイプ選択タブ */}
                        <div className='mb-2' style={{minWidth:"320px"}}>
                            <Tabs 
                                value={contentType} 
                                onChange={(e, newValue) => {
                                    setContentType(newValue)
                                    setImageListReset(true)
                                    setImagePage(1)
                                }} 
                                variant="scrollable"
                                scrollButtons="auto"
                                allowScrollButtonsMobile
                                sx={{
                                    '& .MuiTab-root': {
                                        minWidth: '60px',
                                        fontSize: { xs: '12px', sm: '14px' },
                                        padding: { xs: '6px 8px', sm: '12px 16px' }
                                    },
                                    '& .MuiTabs-flexContainer': {
                                        justifyContent: { xs: 'flex-start', md: 'center' }
                                    }
                                }}
                            >
                                <Tab label="画像" value="image" />
                                <Tab label="文書" value="text" />
                                <Tab label="動画" value="video" />
                                <Tab label="イベント" value="event" />
                                <Tab label="モデル" value="model" />
                            </Tabs>
                        </div>
                    </div>
                </div>
                <Container style={{position:"fixed",top:"180px",zIndex:2,backgroundColor:"inherit",display:showSetting ? "block" : "none",width:"100%",maxWidth:"600px"}} className='p-0'>
                    <AgeSelect to="new" loginInfo={loginInfo} generalOrAI={generalOrAI} styleOfPainting={styleOfPainting} onClick={() => {
                        setImagePage(1)
                    }} />
                    <Row style={{width:"100%",maxWidth:"600px"}}>
                        <Col xs={12} sm={8} md={7} lg={7} xl={7} xxl={7} className="mb-2">
                            <InputGroup>
                                <InputGroup.Checkbox style={{cursor:"pointer"}} checked={omitContinuous} onChange={(e) => {
                                    updateRenzoku(e.currentTarget.checked ? "on" : "off").then(r => {
                                        if(r.result){
                                            isLoggin().then(json => {
                                                setLoginInfo(json)
                                            })
                                        }
                                    })
                                    //setOmitContinuous(e.currentTarget.checked)
                                }} />
                                <Form.Control type="text" value={t("common.deduceConsecutiveSubmissions")} readOnly />
                            </InputGroup>
                        </Col>
                        <Col xs={12} sm={8} md={5} lg={5} xl={5} xxl={5}>
                            <InputGroup>
                                <InputGroup.Checkbox style={{cursor:"pointer"}} checked={tileMode} onChange={(e) => {
                                    updateTile(e.currentTarget.checked ? "on" : "off").then(r => {
                                        if(r.result){
                                            isLoggin().then(json => {
                                                setLoginInfo(json)
                                            })
                                        }
                                    })
                                    //setTileMode(e.currentTarget.checked)
                                    }} />
                                <Form.Control type="text" value={t("common.tileMode")} readOnly />
                            </InputGroup>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </Container>
        <div style={{marginTop:"200px"}}>

        </div>
        {loading ? <Spinner animation="border" size="lg" style={{marginTop:"40px"}} /> : ""}
        {/**
            <Masonry
                breakpointCols={breakpointColumnsObj}
                className="my-masonry-grid"
                columnClassName="my-masonry-grid_column"
                style={{marginTop:"240px"}}
                >
                {imageList.map((data,i) => {
                    if(data.mute === 1 || (omitContinuous && i > 0 && imageList[i-1].user_id === data.user_id) || (data.user_id !== loginInfo.userId && data.search_ban === 1)){
                        return <span data-no={i} className="lazy" key={i}></span>
                    }
                return <Tile data={data} i={i} dialog={dialog} key={i} observer={observer} list={imageList.filter(d => d.mute === 0)} listName={t(("category.new"))} />

                })}
            </Masonry>
         */}
        {/* Model Info Dialog */}
        <ModelInfoDialog
            open={infoDialogOpen}
            onClose={() => setInfoDialogOpen(false)}
            model={selectedModelForInfo}
        />
        {tileMode ? (
            <Box sx={{ marginTop: { xs: "50px", md: "100px" } }}>
                {contentType === 'model' ? (

                    <Box sx={{ flex: 1, overflow: 'auto', p: 2 }}>
                    {loading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                            <CircularProgress />
                        </Box>
                    ) : contentList.length === 0 ? (
                        <Box sx={{ textAlign: 'center', p: 4 }}>
                            <Typography variant="body1">該当するモデルが見つかりません</Typography>
                        </Box>
                    ) : (
                        <Grid container spacing={2}>
                        {contentList.map(model => (
                            <Grid item
                            key={model.id}
                            xs={12 / gridBreakpoints.xs}
                            sm={12 / gridBreakpoints.sm}
                            md={12 / gridBreakpoints.md}
                            lg={12 / gridBreakpoints.lg}
                            xl={12 / gridBreakpoints.xl}
                            >
                            <ModelCard
                                model={model}
                                onSelect={() => {
                                navigate('/model/' + model.model_id);
                                setDialogSelectedModel(model.i_name)
                                }}
                                onToggleFavorite={() => handleToggleFavorite(model.id)}
                                //onShowGallery={() => handleShowGallery(model.id)}
                                onShowInfo={() => handleShowInfo(model.id)}
                                isLoading={favoriteLoading?.[model.id]}
                            />
                            </Grid>
                        ))}
                        </Grid>
                    )}
                    </Box>
                ) :
                <Gallery 
                    images={contentList.map(d => {
                        d.src = ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST + imgPath(contentType) + '/post/t/'+(d.id)+"_m"+ApiFetch.API_THUMB_EXT
                        d.src = (d.limit_div !== "public" && d.plan_access === 0 || d.unit_amount > 0 && d.is_purchased === 0) ? 
                                                (ApiFetch.API_PROTOCOL+'//'+(contentType === "video" ? ApiFetch.VIDEO_HOST : ApiFetch.IMG_HOST)+imgPath(contentType)+'/post/t/'+(d.group_id)+"_in"+ApiFetch.API_THUMB_EXT) : 
                                                ApiFetch.API_PROTOCOL+'//'+(contentType === "video" ? ApiFetch.VIDEO_HOST : ApiFetch.IMG_HOST)+imgPath(contentType)+'/post/t/'+(d.id)+"_m"+ApiFetch.API_THUMB_EXT
                        d.aspect = d.width/d.height
                        return d
                    }).map((d,i) => {
                        if(d.mute === 1 || (omitContinuous &&  i > 0 && contentList[i-1]?.user_id === d.user_id) || (d.user_id !== loginInfo.userId && d.search_ban === 1)){
                            d.isMute = true
                        } else {
                            d.isMute = false
                        }
                        return d
                    })} 
                    dialog={dialog}
                    contentType={contentType}
                />}
            </Box>
        ) : (
        <Box 
            className='d-flex flex-row justify-content-start flex-wrap w-100'
            sx={{
                marginTop: { xs: "250px", md: "300px" }
            }}
        >
            {contentList.map((data,i) => {
                return renderContent(data, i);
            })}
        </Box>
        )}
        <Footer />
    </div>
    )
}

export default New;
